import { Column, Wrapper as Grid } from './style';

export { Column, Grid };



// WEBPACK FOOTER //
// ./src/components/grid/index.js